<template>
    <div>
        <v-text-field type="number" :rules="rules" :step="decimal == undefined || decimal == 0 ? 1 : .1" v-if="isInputActive" v-bind:class='showClass' :color="color" :label="label" v-model="displayValue" @blur="on_blur" @focus="isInputActive = true" :readonly="readonly" :disabled="Number(disabled) === 1 || disabled === ''" @keyup.enter="press_enter"/>
        <v-text-field type="text" :rules="rules" v-if="!isInputActive" v-bind:class='showClass' :color="color" :label="label" v-model="displayValue" @blur="on_blur" @focus="isInputActive = true" :readonly="readonly" :disabled="Number(disabled) === 1 || disabled === ''" @keyup.enter="press_enter"/>
    </div>
</template>
<script>
export default {
    name: 'h-currency-input',
    props: ["value", "label", "disabled", "decimal", "showClass", "readonly", "color", "rules"],
    data: function() {
        return {
            isInputActive: false
        }
    },
    computed: {
        displayValue: {
            get: function() {
                if (this.isInputActive) {
                    // Cursor is inside the input field. unformat display value for user
                    return (this.value || '').toString()
                } else {
                    // User is not modifying now. Format display value for user interface
                    var parseValue = Number(this.value)
                    return this.value ? parseValue.toFixed(this.decimal !== undefined ? this.decimal : 2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,") : '0'
                }
            },
            set: function(modifiedValue) {
                // Parse số từ nhiều định dạng khác nhau (1.000,3 hoặc 1,000.3 v.v.)
                let newValue = this.parseNumber(modifiedValue)
                // Ensure that it is not NaN
                if (isNaN(newValue)) {
                    newValue = 0
                }
                // Note: we cannot set this.value as it is a "prop". It needs to be passed to parent component
                // $emit the event so that parent component gets it
                this.$emit('input', newValue)
            }
        }
    },
    methods: {
        parseNumber(value) {
            // Loại bỏ khoảng trắng và ký tự không phải số/dấu chấm/dấu phẩy
            let str = value.toString().trim().replace(/[^\d.,]/g, '');
            
            if (!str) return 0;
            
            // Đếm số dấu chấm và dấu phẩy
            const dotCount = (str.match(/\./g) || []).length;
            const commaCount = (str.match(/,/g) || []).length;
            
            // Tìm vị trí cuối cùng của dấu chấm và dấu phẩy
            const lastDotIndex = str.lastIndexOf('.');
            const lastCommaIndex = str.lastIndexOf(',');
            
            let result;
            
            // Trường hợp có cả dấu chấm và dấu phẩy
            if (dotCount > 0 && commaCount > 0) {
                // Dấu nào xuất hiện sau cùng là dấu thập phân
                if (lastDotIndex > lastCommaIndex) {
                    // Định dạng: 1,000.3 (dấu phẩy là phân cách nghìn, dấu chấm là thập phân)
                    result = str.replace(/,/g, '');
                } else {
                    // Định dạng: 1.000,3 (dấu chấm là phân cách nghìn, dấu phẩy là thập phân)
                    result = str.replace(/\./g, '').replace(',', '.');
                }
            }
            // Chỉ có dấu phẩy
            else if (commaCount > 0 && dotCount === 0) {
                // Nếu có nhiều dấu phẩy hoặc dấu phẩy cách cuối > 3 ký tự -> phân cách nghìn
                // Ví dụ: 1,000,000 hoặc 1,000
                if (commaCount > 1 || (str.length - lastCommaIndex - 1) > 3) {
                    result = str.replace(/,/g, '');
                } else {
                    // Dấu phẩy là thập phân: 1,3
                    result = str.replace(',', '.');
                }
            }
            // Chỉ có dấu chấm
            else if (dotCount > 0 && commaCount === 0) {
                // Nếu có nhiều dấu chấm hoặc dấu chấm cách cuối > 3 ký tự -> phân cách nghìn
                // Ví dụ: 1.000.000 hoặc 1.000
                if (dotCount > 1 || (str.length - lastDotIndex - 1) > 3) {
                    result = str.replace(/\./g, '');
                } else {
                    // Dấu chấm là thập phân: 1.3
                    result = str;
                }
            }
            // Không có dấu gì cả
            else {
                result = str;
            }
            
            return parseFloat(result) || 0;
        },
        press_enter() {
            this.$emit('press_enter')
        },
        on_blur() {
            this.isInputActive = false;
            this.$emit('on_blur')
        }
    }
}
</script>
